import { render, staticRenderFns } from "./salesReturnCenter.vue?vue&type=template&id=3002292b&scoped=true"
import script from "./salesReturnCenter.vue?vue&type=script&lang=js"
export * from "./salesReturnCenter.vue?vue&type=script&lang=js"
import style0 from "./salesReturnCenter.vue?vue&type=style&index=0&id=3002292b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002292b",
  null
  
)

export default component.exports